// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"22c89b8e","636":"1d77d3f6","700":"e9a6d2b7","886":"2197dbe3","903":"6930cf0f"}[chunkId] + ".chunk.css";
};